import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
// import ElementPlus from 'element-plus';
import '@/assets/css/reset.css'
import { LocaleInjectionKey, localeProviderMaker } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/css/theme/index.scss'
import '@/assets/css/index.css'
import '@/assets/css/media.css'
// import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'
import tips from '@/common/tips'
import axios from '@/common/axios'
import tools from '@/common/tool'
import urls from '@/common/urls'
import config from '@/common/config'
import Video from 'video.js'// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'video.js/dist/video-js.css' 
// import vConsole from "@/common/vconsole"
let Vue = createApp(App)
// Vue.use(ElementPlus)
Vue.use(router)
Vue.use(store)

const opts = { locale: zhCn };
const localeProvides = localeProviderMaker(opts.locale);
Vue.provide(LocaleInjectionKey, localeProvides);

Vue.config.globalProperties.$video = Video
Vue.config.globalProperties.$tips = tips
Vue.config.globalProperties.$axios = axios
Vue.config.globalProperties.$config = config
Vue.config.globalProperties.$urls = urls
Vue.config.globalProperties.$tools = tools

// Vue.directive('clickoutside', function (el) {
//   let dom = el.querySelector(".el-input__inner");
//   dom.addEventListener("blur", function () {
//     setTimeout(() => {
//       dom.removeAttribute("readonly");
//     }, 200);
//   });  
// })
//解决IOS下拉框搜索没有弹出键盘的问题,下拉搜索框务必加上el-custom-filterable样式
Vue.mixin({
    mounted() {
        if (typeof this.$el.className === 'string') {
            if (this.$el.className.split(' ').indexOf('el-select') !== -1 && this.$el.className.split(' ').indexOf('el-custom-filterable') !== -1) {
                this.$el.children[0].children[0].children[0].removeAttribute('readOnly')
                this.$el.children[0].children[0].children[0].onblur = function () {
                    let _this = this
                    setTimeout(() => {
                        _this.removeAttribute('readOnly')
                    }, 200)
                }
            }
        }
    }
})
Vue.mount('#app')
